import React from 'react'
import PropTypes from 'prop-types'
import CustomSelect from '../CustomSelect/CustomSelect'
import './selectWithSearchField.module.scss'

const SelectField = (props) => {
  const {
    field: { name, value },
    form: { setFieldValue },
    onSearch,
    options,
    placeholder,
    loading,
    optionFilterProp,
    filterOption
  } = props

  return (
    <CustomSelect
      name={name}
      value={value}
      showSearch
      loading={loading}
      placeholder={placeholder}
      options={options}
      optionFilterProp={optionFilterProp}
      filterOption={filterOption}
      onSearch={onSearch}
      onChange={(valueSelected) => {
        setFieldValue(name, valueSelected)
      }}
    />
  )
}

SelectField.defaultProps = {
  field: undefined,
  form: undefined,
  placeholder: 'Digite ou selecione',
  loading: false,
  options: [],
  onSearch: null,
  optionFilterProp: null,
  filterOption: false
}

SelectField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func
  }),
  options: PropTypes.array,
  placeholder: PropTypes.string,
  optionFilterProp: PropTypes.string,
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
  filterOption: PropTypes.bool
}

export default SelectField
